<div class="gray-bg-rounded mb-3">
  <form>
    <div class="clientdetails-section mb-4">
      <header
        class="d-flex align-items-center justify-content-between px-3 pe-5 py-2 position-relative">
        <h2 class="mb-0">Details</h2>
      </header>
      <div class="px-3 pt-3">
        <div class="row">
          <div class="col-6 leftfivecol">
            <div class="row">
              <div class="col-2 mb-3">
                <label class="title">Order #</label>
                <div class="text">
                  <a
                    class="link"
                    (click)="
                      onOrderSelection(
                        invoicereviewHeaderResponse?.SalesOrderNumber || ''
                      )
                    ">
                    {{ invoicereviewHeaderResponse?.SalesOrderNumber }}
                  </a>
                </div>
              </div>
              <div class="col-3 mb-3">
                <label class="title">InhandDate</label>
                <div class="text">
                  <label
                    *ngIf="
                      invoicereviewHeaderResponse?.InHandsDate
                        | hidedynamicsdate
                    ">
                    {{
                      invoicereviewHeaderResponse?.InHandsDate
                        | date: "MM-dd-yyyy"
                    }}
                  </label>
                </div>
              </div>
              <div class="col-3 mb-3">
                <label class="title">Customer</label>
                <div class="text">
                  <a
                    class="link"
                    (click)="
                      onClientSelection(
                        invoicereviewHeaderResponse?.Customer || ''
                      )
                    ">
                    {{ invoicereviewHeaderResponse?.Customer }}
                  </a>
                </div>
              </div>
              <div class="col-2 mb-3">
                <label class="title">Buyer</label>
                <label class="text">
                  {{ invoicereviewHeaderResponse?.Buyer }}
                </label>
              </div>
              <div class="col-2 addseparator">
                <label class="title">Total Sell</label>
                <div class="text">
                  <label class="text">
                    {{
                      invoicereviewHeaderResponse?.TotalSell
                        | currency: "USD" : "symbol" : "0.2-2"
                    }}
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <!-- <div class="col-2 mb-3">
                <div class="title">Biller</div>
                <div class="text">
                  {{ invoicereviewHeaderResponse?.Biller }}
                </div>
              </div> -->
              <!-- <div class="col-3 mb-3">
                <div class="title">Ready to bill</div>
                <div class="text">
                  {{ invoicereviewHeaderResponse?.ReadyToBill }}
                </div>
              </div> -->

              <div class="col-2 mb-3">
                <label class="title">Client PO</label>
                <div class="text">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    id="customerPONumber"
                    class="hideborder editableinputfield"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="customerPONumber"
                    (focusout)="updateProjectInvoiceReviewDetails()" />
                </div>
              </div>
              <div class="col-3 mb-3">
                <label class="title">Job Name</label>
                <div class="text">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    type="text"
                    id="jobName"
                    class="hideborder editableinputfield"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="jobName"
                    (focusout)="updateProjectInvoiceReviewDetails()" />
                </div>
              </div>

              <div class="col-5 mb-3">
                <label class="title">Freight Method.</label>

                <div class="text">
                  <p-select
                    id="currency"
                    [appendTo]="'body'"
                    [(ngModel)]="shippingMethodCode"
                    [ngModelOptions]="{ standalone: true }"
                    (onChange)="updateProjectInvoiceReviewDetails()"
                    [filter]="true"
                    [showClear]="true"
                    [options]="shippingProductsList"
                    optionLabel="modeDescriptionD365"
                    optionValue="modeCodeD365">
                  </p-select>
                </div>
                <div class="title"></div>
                <div class="text"></div>
              </div>

              <div class="col-2 mb-3 addseparator">
                <label class="title mb-1">GP %</label>
                <label class="text">
                  {{ invoicereviewHeaderResponse?.GP | number: "0.2-2" }}%
                </label>
              </div>
            </div>
          </div>
          <div class="col-6 rightsixcol">
            <div class="row">
              <div class="col-2">
                <label class="title">Total Cost</label>
                <div class="text">
                  <label class="text">
                    {{
                      invoicereviewHeaderResponse?.TotalCost
                        | currency: "USD" : "symbol" : "0.2-2"
                    }}
                  </label>
                </div>
              </div>
              <div class="col-2">
                <label class="title">Net GP%</label>
                <label class="text">
                  {{
                    invoicereviewHeaderResponse?.NetGPPercent | number: "0.2-2"
                  }}%
                </label>
              </div>
              <div class="col-2 addseparator">
                <label class="title">Est Freight</label>
                <label class="text">
                  {{
                    invoicereviewHeaderResponse?.EstFreight
                      | currency: "USD" : "symbol" : "0.2-2"
                  }}
                </label>
              </div>
              <div class="col-2">
                <label class="title">Total Freight</label>
                <a class="link" (click)="redirectToFreightChargesPage()">
                  <span class="freight-color"> </span>
                  {{
                    invoicereviewHeaderResponse?.TotalFreight
                      | currency: "USD" : "symbol" : "0.2-2"
                  }}
                </a>
              </div>
              <div class="col-2 addseparator">
                <label class="title">Client deposit</label>
                <!-- <a class="link" (click)="redirectToClientDepositPage()">
                  <span class="freight-color"> </span
                  >
                  {{
                    invoicereviewHeaderResponse?.ClientDeposit
                      | currency: 'USD':'symbol':'0.2-2'
                  }}
                  </a> -->
                <label class="text">
                  {{
                    invoicereviewHeaderResponse?.ClientDeposit
                      | currency: "USD" : "symbol" : "0.2-2"
                  }}
                </label>
              </div>
              <div class="col-2">
                <label class="title">Total Invoice</label>
                <div class="text">
                  <label class="text">
                    {{
                      invoicereviewHeaderResponse?.TotalInvoice
                        | currency: "USD" : "symbol" : "0.2-2"
                    }}
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-2 mb-3">
                <label class="title">Net Com</label>
                <label class="text">
                  {{
                    invoicereviewHeaderResponse?.NetCommission
                      | currency: "USD" : "symbol" : "0.2-2"
                  }}
                </label>
              </div>

              <div class="col-2 mb-3">
                <div class="title"></div>
                <div class="text"></div>
              </div>
              <div class="col-2 mb-3 addseparator">
                <label class="title">Est Tax</label>
                <div class="text">
                  <label class="text">
                    {{
                      invoicereviewHeaderResponse?.EstTax
                        | currency: "USD" : "symbol" : "0.2-2"
                    }}
                  </label>
                </div>
              </div>
              <!-- <div class="col-2 mb-3">
                <div class="title">Total Tax</div>
                <div class="text">
                  <div class="text">
                    {{
                      invoicereviewHeaderResponse?.TotalTax
                        | currency: 'USD':'symbol':'0.2-2'
                    }}
                  </div>
                </div>
              </div> -->

              <!-- <div class="col-2 mb-3 addseparator">
                <div class="title">Freight Method</div>
                <div class="text"></div>
              </div> -->
              <!-- <div class="col-2 mb-3">
                <div class="title">D365 Status</div>
                <div
                  class="text"
                  [title]="invoicereviewHeaderResponse?.StatusCode"
                  style="
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                >
                  {{ invoicereviewHeaderResponse?.StatusCode }}
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [saleOrderIdFromModal]="salesOrderId"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (closeOrderSummaryModalEvent)="
        closeModalForSaleOrder()
      "></jni-order-summary>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeModalForClient()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [clientIdFromModal]="clientId"
      (scrollHiddenStatus)="addScollHiddenClass()"
      (closeEvent)="closeModalForClient()"
      [isModal]="true">
    </jni-client-details>
  </div>
</jni-modal-stacker>

<!-- <jni-modal-stacker
  *ngIf="freightChargesDisplayModal"
  [displayModal]="freightChargesDisplayModal"
  (closeEvent)="closeModalForFreight()"
>
  <h1 class="panelHeading">Freight Charges</h1>
  <div class="panelBody">
    <jni-invoice-Review-freight-charges [saleOrderId]="salesOrderId">
    </jni-invoice-Review-freight-charges>
  </div>
</jni-modal-stacker> -->

<jni-modal-stacker
  *ngIf="clientDepositDisplayModal"
  [displayModal]="clientDepositDisplayModal"
  (closeEvent)="closeModalForClientDeposit()">
  <h1 class="panelHeading">Client Deposit</h1>
  <div class="panelBody">
    <jni-invoice-review-client-deposit
      [invoiceReviewNumber]="invoiceReviewNumber">
    </jni-invoice-review-client-deposit>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="freightChargesDisplayModal"
  [displayModal]="freightChargesDisplayModal"
  (closeEvent)="closeModalForFreight()">
  <h1 class="panelHeading">Freight Charges</h1>
  <div class="panelBody">
    <jni-freight-charges
      [isModal]="true"
      [saleOrderId]="salesOrderId || ''"
      (scrollHiddenStatus)="addScollHiddenClass()">
    </jni-freight-charges>
  </div>
</jni-modal-stacker>
